import { http } from '@/environment/environment';
import store from '@/store';

class OnboardingChecklistService
{
    createOnboardingChecklist(userId: string, jwtToken: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.post(`users/${userId}/onboarding`);
    }

    updateOnboardingChecklist(userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.put(`users/${userId}/onboarding`, data);
    }

    getOnboardingChecklist(userId: string, jwtToken: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = jwtToken;
        return http.get(`users/${userId}/onboarding`);
    }

    saveUpdatedOnboardingChecklist(data: any, checklistIndex: number, userId: string, jwtToken: string) {
        if (!data[checklistIndex].isDone) {
            data[checklistIndex].isDone = true;
            this.updateOnboardingChecklist(userId, jwtToken, data);
            store.dispatch('onboarding/checklistTrue', checklistIndex);
            store.dispatch('onboarding/progressCount');
        }
    }
}

export default new OnboardingChecklistService();